import CollectionChoiceMixin from '~/mixins/collection-choice/collection-choice'
import SendCollectionChoice from '~/mixins/collection-choice/send-collection-choice'

export default {
  mixins: [SendCollectionChoice, CollectionChoiceMixin],
  data () {
    return {
      fields: {
        zipCode: {
          value: '',
          type: 'number',
          required: true,
          isInvalid: null
        }
      },
      phone: {
        value: '',
        required: false,
        type: 'number',
        isInvalid: null
      }
    }
  },
  methods: {
    updateSrcGoogleMapsEmbed (map, zipCode) {
      const { src: currentSrc } = map
      const lastZipCode = currentSrc.match(/.*\+(.*)/)[1]
      map.src = currentSrc.replace(lastZipCode, zipCode)
    },
    searchForNearLab (zipCode) {
      const stateCode = this.getStateCode(zipCode)
      const statesLabNotAvailable = ['NJ', 'RI', 'HI']
      const isNYState = stateCode === 'NY'
      const isStateLabNotAvailable = statesLabNotAvailable.includes(stateCode)
      const map = document.getElementById('google-maps-embed')

      if (isStateLabNotAvailable) {
        this.$toast.error(`Visits not available in ${stateCode}`)
      } else if (isNYState) {
        this.error = 'We are sorry, right now Quest is not serving members in NY. We offer FaceTime sessions for users that have a finger-prick test to assist them with at-home collection. <br>Please select at-home collection or reach out to the team via <a class="text-decoration-underline" href="mailto:members@get-base.com">members@get-base.com</a> to evaluate other options'
      } else if (!map) {
        throw new Error('Google Maps iframe with id=google-maps-embed is needed in order to search a lab.')
      } else {
        this.updateSrcGoogleMapsEmbed(map, zipCode)
      }
    },
    validateLabCollectionForm () {
      this.validateZipCode()
    },
    async sendLabCollectionChoiceRequest () {
      this.clearErrors()
      try {
        this.validateLabCollectionForm()
      } catch (e) {
        this.error = e.error
        this.markFieldAsError(e.field)
        return
      }
      const zipCode = this.getFormFieldParam('zipCode', 'value')
      const phone = this.phone.value

      try {
        const referralLink = await this.sendCollectionChoiceMethodData({
          collectionChoice: 1,
          userEmail: this.accountCreated,
          zipCode,
          phone
        })
        await this.$store.dispatch('user/setReferralLink', referralLink)
        await this.$store.dispatch('user/setCollectionChoice', 'lab')
        await this.$store.dispatch('user/setAccountCreated', null)
        window.location.href = 'thanks'
      } catch (e) {
        this.$toast.error(e.message)
      }
    }
  }
}
